import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import swal from 'sweetalert';
import Select from "react-select";

import Logo from "./splash_ok.png";
import imgFatura from "./imgFatMobile.jpg";
import { Form, Container, Label, NomeEmpresa } from "./styles";

import { Button, Image } from 'react-bootstrap';
import Modal from 'react-modal';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

function Login() {
  const [nome, setNome] = useState("");
  const [produtor, setProdutor] = useState("");
  const [clientes, setClientes] = useState([]);
  const [listaClientes, setListaClientes] = useState([]);
  const [selectedOptionCliente, setSelectedOptionCliente] = useState([]);

  const navegador = useNavigate();

  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  //Executa esse código assim que o arquivo é chamado
  useEffect(() => {
    getListaClientes();

    async function getListaClientes() {
      setClientes([]);

      await fetch(`https://lpsistemas.dev.br/adm/api/produtor/services/getempresas.php`)
        .then((response) => response.json())
        .then((responseJson) => {
          setClientes(responseJson);

          let vArrayData = [];
          let vdata = [];
          for (var [key, value] of Object.entries(responseJson)) {
            vdata = {
              "value": value.id,
              "label": value.razao,
            }

            vArrayData.push(vdata);
          }

          setListaClientes(vArrayData);
        })
    }
  }, []);

  //Anula o evento do formulário
  function handleSignIn(e) {
    e.preventDefault();
  };

  async function fazerLogin() {
    try {
      //Pega o valor
      let idcli;
      let vEndereco = window.location.pathname;
      idcli = vEndereco.slice(5, 10);

      let idcliente = idcli;
      if (selectedOptionCliente.value) {
        idcliente = selectedOptionCliente.value;
      }

      if (nome === "") {
        swal("Por favor, preencha corretamente os campos!", "");
      } else {
        await fetch(
          `https://lpsistemas.dev.br/adm/api/produtor/services/validaprodutor.php?produtor=${produtor}&idcliente=${idcliente}&cpf_cnpj=${nome}&senha=`)
          .then((response) => response.json())
          .then((responseJson) => {

            if (responseJson && Object.keys(responseJson).length !== 0) {
              localStorage.setItem("produtor", responseJson[0].id_produtor);
              localStorage.setItem("cliente", responseJson[0].id_cliente);

              // Manda para a página dashboard
              navegador("/dashboard");
            } else {
              swal("Login não autorizado!", "Por favor, refaça o login!");
              return false;
            }
          });
      }
    } catch (error) {
      swal("Login não autorizado!", "Por favor, refaça o login!");
      return false;
    }
  }

  function renderClientes() {
    let idcliente;
    let vEndereco = window.location.pathname;
    idcliente = vEndereco.slice(5, 10);

    if (idcliente > 0) {
      return <div>
      </div>;
    } else {
      return <div style={{ width: '100%' }} >
        <center>
          <Label>Informe um perímetro</Label>
        </center>
        <Select
          placeholder={"Selecione um perímetro"}
          isMulti={false}
          options={listaClientes}
          isOptionSelected={selectedOptionCliente}
          defaultValue={selectedOptionCliente}
          onChange={setSelectedOptionCliente}
        />
      </div>;
    }
  }

  return (
    <Container style={{ backgroundColor: '#f5f5f5' }} >
      <Form onSubmit={handleSignIn}>

        <img style={{ height: 130, width: 130 }} src={Logo} alt="Euro" />
        <NomeEmpresa>2ª via de boletos</NomeEmpresa>

        <Label>Informe seu CPF ou CNPJ</Label>
        <input
          type="text"
          placeholder="CPF ou CNPJ"
          value={nome}
          onChange={(e) => setNome(e.target.value)}
        />

        <Label>Informe o código do produtor</Label>
        <div style={{ display: 'flex', flexDirection: 'row' }} >
          <input
            style={{ width: 320, height: 28 }}
            type="text"
            placeholder="Código do produtor"
            value={produtor}
            onChange={(e) => setProdutor(e.target.value)}
          />
          <Button variant="primary" onClick={openModal} style={{
            width: 35,
            height: 35,
            marginTop: -2,
            marginLeft: 5,
            cursor: 'pointer'
          }} >?</Button>
        </div>

        {renderClientes()}

        <button style={{
          marginTop: 30,
          cursor: 'pointer'
        }} onClick={() => fazerLogin()} type="submit">Entrar</button>
      </Form>

      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div style={{ textAlign: 'center', marginBottom: 10 }} >Fatura</div>
          <form>
            <center>
              <Image
                style={{
                  width: 300,
                  height: 240
                }}
                src={imgFatura}
              />
            </center>
          </form>

          <div style={{ textAlign: 'center', marginTop: 15, cursor: 'pointer' }} >
            <Button style={{
              height: 28,
            }} variant="secondary" onClick={closeModal}>
              Fechar
            </Button>
          </div>
        </Modal>
      </div>
    </Container>
  );
}

export default Login;
